import { Redirect, Router } from '@reach/router';
import React from 'react';
import { ApolloProvider } from 'react-apollo';
import { ApolloProvider as ApolloHooksProvider } from 'react-apollo-hooks';
import { toast, ToastContainer } from 'react-toastify';
import { Icon } from './components/ui';
import { ErrorBoundary, PleaseSignIn, Tachyons } from './components/utils';
import PleaseSelectNotebook from './components/utils/PleaseSelectNotebook';
import PleaseSelectNotebookForNote from './components/utils/PleaseSelectNotebookForNote';
import client from './lib/client';
import HomePage from './pages';
import UserSettingsPage from './pages/account';
import { AdminDashboard, Invite } from './pages/admin';
import JoinAccount from './pages/join';
// Pages
import Login from './pages/Login';
import { Boom, Clear, MetaIndex, Version } from './pages/meta';
import Dashboard from './pages/notebook/dashboard';
import NotebookTimeline from './pages/notebook/feed';
import GroupDelete from './pages/notebook/group/delete';
import Group from './pages/notebook/group/id/index';
import NoteEdit from './pages/notebook/note/edit';
// Note
import Note from './pages/notebook/note/index';
import NoteNew from './pages/notebook/note/new';
import Search from './pages/notebook/search';
// Account
import AccountSettings from './pages/notebook/settings';
import NotebookDelete from './pages/notebook/settings/delete';
import SubjectDelete from './pages/notebook/subject/delete';
import Subject from './pages/notebook/subject/id';
import TrackerDelete from './pages/notebook/tracker/delete';
import NotebookTemplatesPage from './pages/notebookTemplates';
import NotFound from './pages/NotFound';
import Register from './pages/Register';
import WelcomePage from './pages/welcome';
import Error404 from './pages/Error404';

const App = () => {
  return (
    <Tachyons>
      <ErrorBoundary>
        <ApolloProvider client={client}>
          <ApolloHooksProvider client={client}>
            <Router>
              <Login path="/login" />
              <Register path="/register" />
              <JoinAccount path="/join/:inviteCode" />

              <PleaseSignIn path="/" className="bg-blue">
                <HomePage path="/" />
                <NotebookTemplatesPage path="/notebookTemplates" />

                {/* Notebook */}
                <PleaseSelectNotebook path="/notebook">
                  <Dashboard path="/" />

                  {/* Timeline */}
                  <NotebookTimeline path="/feed" />

                  {/* Groups */}
                  <Redirect from="/group" to="/notebook/dashboard" noThrow />
                  <Group path="/group/:groupSlug" />
                  <GroupDelete path="/group/:groupId/delete" />

                  {/* Subjects */}
                  <Redirect from="/subject" to="/notebook/dashboard" noThrow />
                  <Subject path="/subject/:subjectSlug" />
                  <SubjectDelete path="/subject/:subjectId/delete" />

                  {/* Trackers */}
                  <TrackerDelete path="/tracker/:trackerId/delete" />

                  {/* Settings */}
                  <AccountSettings path="/settings" />
                  <NotebookDelete path="/delete" />

                  {/* Search */}
                  <Search path="/search" />

                  {/* Account */}
                  <UserSettingsPage path="/account" />

                  <NotFound default />
                </PleaseSelectNotebook>

                {/* Notes */}
                <PleaseSelectNotebookForNote path="/notebook/note">
                  <Note path="/:noteId" />
                  <NoteNew path="/new" />
                  <NoteEdit path="/:noteId/edit" />
                </PleaseSelectNotebookForNote>

                {/* Welcome */}
                <WelcomePage path="/welcome" />

                {/* Admin */}
                <AdminDashboard path="/admin" />
                <Invite path="/admin/invite" />

                {/* Meta */}
                <MetaIndex path="/meta">
                  <Boom path="/boom" />
                  <Clear path="/clear" />
                  <Version path="/version" />
                </MetaIndex>

                <Error404 default />
              </PleaseSignIn>
            </Router>
          </ApolloHooksProvider>
        </ApolloProvider>
        <ToastContainer
          hideProgressBar
          position={toast.POSITION.BOTTOM_LEFT}
          closeButton={<Icon name="close" color="navy" size={14} />}
        />
      </ErrorBoundary>
    </Tachyons>
  );
};

export default App;
